import type { components } from "@/api-schema";
import { automaticCellRenderer } from "@/components/data-table/_helpers/cell-renderer";
import { roundVehicleValuationPriceForDisplay } from "@/modules/fab/vehicle-valuation/_helpers/vehicle-valuation-derived-values";
import type { ReactNode } from "react";

type VehicleValuation = components["schemas"]["VehicleValuation"];

export interface HistoryColumn {
  headerKey: string;
  align?: "left" | "right";
  hiddenOnMobile?: boolean;
  skeletonWidth: string;
  render: (entry: VehicleValuation) => ReactNode;
}

export const HISTORY_COLUMNS: HistoryColumn[] = [
  {
    headerKey: "fab:ConfirmedAt",
    skeletonWidth: "w-20",
    render: (entry) => automaticCellRenderer(entry.confirmedAt, { dateFormat: "date" }),
  },
  {
    headerKey: "fab:Mileage",
    align: "right",
    hiddenOnMobile: true,
    skeletonWidth: "w-12",
    render: (entry) => automaticCellRenderer(entry.mileageUsed),
  },
  {
    headerKey: "fab:NumberOfHolders",
    align: "right",
    hiddenOnMobile: true,
    skeletonWidth: "w-16",
    render: (entry) => automaticCellRenderer(entry.numberOfHoldersUsed),
  },
  {
    headerKey: "fab:SalesGross",
    align: "right",
    skeletonWidth: "w-16",
    render: (entry) =>
      automaticCellRenderer(roundVehicleValuationPriceForDisplay(entry.confirmedSalesGross), {
        numberFormat: "currency",
        numberDecimals: 0,
      }),
  },
  {
    headerKey: "fab:MarginPercentage",
    align: "right",
    skeletonWidth: "w-10",
    render: (entry) =>
      automaticCellRenderer(entry.confirmedMarginPercentage, { numberFormat: "percentage", numberDecimals: 1 }),
  },
  {
    headerKey: "fab:TradeGross",
    align: "right",
    hiddenOnMobile: true,
    skeletonWidth: "w-24",
    render: (entry) =>
      automaticCellRenderer(roundVehicleValuationPriceForDisplay(entry.confirmedTradeGross), {
        numberFormat: "currency",
        numberDecimals: 0,
      }),
  },
];
